import GNB from '@/common/resources/GNB'
import _ from 'lodash'
import fp from 'lodash/fp'
import { EVENT_TYPE, MENU, UI_CODE } from '@/common/resources/const'
import { getTimeStamp } from '@/common/utils/common'

const getGnbList = () => _.get(GNB, 'gnblist')
const curriedFilterFn = (uiCode) => (gnb) => gnb.uicode === uiCode
const curriedEventTypeFilter = (eventType) => (event) => event.type === eventType
const getEventObjectByType = (eventType) => fp.flow(fp.filter(curriedEventTypeFilter(eventType)), fp.first)
const GNBEventMapper = (eventList) => {
  return {
    onClick: getEventObjectByType(EVENT_TYPE.ON_CLICK)(eventList),
    onContent: getEventObjectByType(EVENT_TYPE.ON_CONTENT)(eventList)
  }
}
const SectionEventMapper = (eventList) => {
  return {
    onClick: getEventObjectByType(EVENT_TYPE.ON_CLICK)(eventList),
    onContent: getEventObjectByType(EVENT_TYPE.ON_CONTENT)(eventList),
    onViewMore: getEventObjectByType(EVENT_TYPE.ON_VIEW_MORE)(eventList),
    onNavigation: getEventObjectByType(EVENT_TYPE.ON_NAVIGATION)(eventList),
    onMoveTab: getEventObjectByType(EVENT_TYPE.ON_MOVE_TAB)(eventList)
  }
}
const CellEventMapper = (eventList) => {
  return {
    onClick: getEventObjectByType(EVENT_TYPE.ON_CLICK)(eventList),
    onNavigation: getEventObjectByType(EVENT_TYPE.ON_NAVIGATION)(eventList)
  }
}

const getGnbEventListByUiCode = (uiCode) => {
  return fp.flow(
    getGnbList,
    fp.filter(curriedFilterFn(uiCode)),
    fp.first,
    fp.get('eventlist'),
    fp.thru(GNBEventMapper)
  )()
}
export const getSectionEventObject = fp.thru(SectionEventMapper)
export const getCellEventObject = fp.thru(CellEventMapper)
export const getSectionEventByType = (eventType) => fp.flow(
  fp.getOr([], 'eventlist'),
  getSectionEventObject,
  fp.find(event => _.get(event, 'type', '') === eventType)
)

export const GNB_EVENT_LIST = {
  [MENU.HOME]: getGnbEventListByUiCode(UI_CODE.HOME),
  [MENU.BROADCAST]: getGnbEventListByUiCode(UI_CODE.BROADCAST),
  [MENU.LIVE]: getGnbEventListByUiCode(UI_CODE.LIVE),
  [MENU.MOVIE]: getGnbEventListByUiCode(UI_CODE.MOVIE),
  [MENU.GLOBAL]: getGnbEventListByUiCode(UI_CODE.GLOBAL),
  [MENU.CLIP]: getGnbEventListByUiCode(UI_CODE.CLIP)
}

export const eventBodyListParser = fp.flow(
  fp.getOr([], 'bodylist'),
  fp.map(fp.split(':')),
  fp.fromPairs,
  fp.thru(val => _.set(val, 'timestamp', getTimeStamp()))
)

export const getBand = fp.flow(
  fp.getOr([], ['data', 'band'])
)
export const getCellList = fp.flow(
  getBand,
  fp.getOr([], 'celllist')
)
